// ----------------------------------------------------------------------
// <copyright file="Izenda.RangeRecurrence.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function () {
  "use strict";

  var m = require('mobx');
  var React = require('react');
  var observer = require('mobx-react').observer;
  var Validator = require('share/components/hoc/Izenda.Validator');
  var DateTimePicker = require('share/components/controls/DateTime/Izenda.DateTimePicker');
  var Input = require('share/components/controls/Izenda.Input');
  var NumericInput = require('share/components/controls/Izenda.NumericInput');
  var ValidatableDateTimePicker = Validator()(DateTimePicker);
  var momentTimezone = require('moment-timezone');
  var localizer = require('share/localization/Izenda.Localizer');
  var DEFAULT_OCCURRENCE = require('logic/data/Izenda.ScheduleConstants').DEFAULT_OCCURRENCE;
  var AppGlobalConstants = require('logic/data/Izenda.AppGlobalConstants');
  var DATE_FORMAT = AppGlobalConstants.DATE_FORMAT;

  var RangeRecurrence = React.createClass({
    propTypes: {
      data: React.PropTypes.object
    },

    componentWillMount: function () {
      this.subData = this.props.data;
    },

    /**
     * get checked for no end date radio
     * @return {boolean} isEndless
     */
    getCheckedNoEndDate: function () {
      return this.subData.isEndless;
    },

    /**
     * onchange no end date radio
     */
    onChangeNoEndDate: function () {
      m.transaction(function () {
        this.subData.isEndAfter = false;
        this.subData.isEndBy = false;
        this.subData.isEndless = true;
        this.subData.markDirty();
      }.bind(this));
    },

    /**
     * get checked for end after radio
     */
    getCheckedEndAfter: function () {
      return this.subData.isEndAfter;
    },

    /**
     * onchange end after radio
     */
    onChangeEndAfter: function () {
      m.transaction(function () {
        this.subData.isEndAfter = true;
        this.subData.isEndBy = false;
        this.subData.isEndless = false;
        this.subData.occurrence = DEFAULT_OCCURRENCE;
        this.subData.markDirty();
      }.bind(this));
    },

    /**
     * get checked for end by radio
     * @return {boolean} isEndBy
     */
    getCheckedEndBy: function () {
      return this.subData.isEndBy;
    },

    /**
     * onchange end by radio
     */
    onChangeEndBy: function () {
      m.transaction(function () {
        this.subData.isEndAfter = false;
        this.subData.isEndBy = true;
        this.subData.isEndless = false;
        this.subData.endDate = momentTimezone().format(DATE_FORMAT);
        this.subData.markDirty();
        this.props.validateEndDateWithStartDate(false); // false is End date vs Start date
      }.bind(this));
    },

    /**
     * get occurrence
     * @return {number} occurrence
     */
    getOccurrence: function () {
      return this.subData.occurrence;
    },

    /**
     * onchange occurrence input
     */
    onChangeOccurrence: function (value) {
      this.subData.updateProperty && this.subData.updateProperty('occurrence', value);
    },

    /**
     * get end by datepicker
     * @return {Date} endDate
     */
    getEndBy: function () {
      return (
        (this.subData.endDate && momentTimezone(this.subData.endDate).format(DATE_FORMAT)) ||
        momentTimezone().format(DATE_FORMAT)
      );
    },

    /**
     * onchange end by datepicker
     * @param {object} date
     */
    onChangeEndByDatePicker: function (date) {
      this.subData.updateProperty && this.subData.updateProperty('endDate', date);
      this.props.validateEndDateWithStartDate(false); // false is End date vs Start date
    },

    /**
     * Render componennt
     */
    render: function () {
      return (
        <div>
          <div>{localizer.getText('DASHBOARD_LABEL_RANGE_OF_RECURRENCE')}</div>
          <hr />
          <div className='form-group'>
            <div className='col-md-12 control-label'>
              <Input type='radio'
                name='range'
                checked={this.getCheckedNoEndDate() }
                onChange={this.onChangeNoEndDate} />
              <span className='radio-label'>{localizer.getText('SUBSCRIPTION_LABEL_NO_END_DAY')}</span>
            </div>
          </div>
          <div className='form-group'>
            <div className='col-md-3 control-label'>
              <Input type='radio'
                name='range'
                checked={this.getCheckedEndAfter() }
                onChange={this.onChangeEndAfter} />
              <span className='radio-label'>{localizer.getText('SUBSCRIPTION_LABEL_END_AFTER')}</span>
            </div>
            <div className='col-md-3'>
              <NumericInput
                value={this.getOccurrence() }
                onChange={this.onChangeOccurrence}
                disabled={!this.getCheckedEndAfter() }
                max={Math.pow(2, 32)} />
            </div>
            <div className='col-md-3 control-label no-padding-left'>{localizer.getText('SUBSCRIPTION_LABEL_OCCURRENCES')}</div>
          </div>
          <div className='form-group'>
            <div className='col-md-3 control-label'>
              <Input type='radio'
                name='range'
                checked={this.getCheckedEndBy() }
                onChange={this.onChangeEndBy} />
              <span className='radio-label'>{localizer.getText('SUBSCRIPTION_LABEL_END_BY')}</span>
            </div>
            <div className='col-md-3'>
              <ValidatableDateTimePicker time={false}
                value={this.getEndBy() }
                onChange={this.onChangeEndByDatePicker}
                disabled={!this.getCheckedEndBy() }
                field='endDate' />
            </div>
          </div>
        </div>
      );
    }
  });

  module.exports = observer(RangeRecurrence);
} ());


// WEBPACK FOOTER //
// ./ui/modules/Subscription/Izenda.RangeRecurrence.jsx